import React, { useEffect } from 'react'
import HeaderTitle from '../../components/HeaderTitle'
import { Helmet } from 'react-helmet'

import './dashboard.scss';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ControlPage from '../Auth/ControlPage';
import { isAdmin } from '../../utils/roleUtils';

function Dashboard() {
    const { role } = useSelector((state) => state.auth)
    const navigate = useNavigate();

    if (!isAdmin(role)) {
        return (
            <ControlPage />
        );
    }

    return (
        <div className='container-fluid'>
            <Helmet>
                <title>Dashboard</title>
                <meta name='description' content='Dashboard' />
                <meta name='viewport' content='width=device-width, initial-scale=1.0' />
            </Helmet>
            <HeaderTitle title="Başlangıç" description="Başlangıç sayfasıdır." />
            <div className='row dashboard'>
                <div className='col-md-3'>
                    <div className='card'>
                        <div className='card-body'>
                            <h5 className='card-title'>Laboratuvar</h5>
                            <p className='card-text'>Laboratuvarlar hakkında bilgi alabilirsiniz.</p>

                            <p>
                                <i className='bi bi-geo-alt me-2'></i>
                                Lab Name
                            </p>
                            <p>
                                <i className='bi bi-clock me-2'></i>
                                Open Time - Close Time
                            </p>
                        </div>
                    </div>
                </div>

                <div className='col-md-3'>
                    <div className='card'>
                        <div className='card-body'>
                            <h5 className='card-title'>Talep Durumu</h5>
                            <p className='card-text'>Talepler hakkında bilgi alabilirsiniz.</p>

                            <p>
                                <i className='bi bi-bell me-2'></i> 100 Açık Talep
                            </p>
                            <p>
                                <i className='bi bi-check-circle me-2'></i> 1000 Tamamlanan Talep
                            </p>
                        </div>
                    </div>
                </div>

                <div className='col-md-3'>
                    <div className='card'>
                        <div className='card-body'>
                            <h5 className='card-title'>Firmalar</h5>
                            <p className='card-text'>Firmalar hakkında bilgi alabilirsiniz.</p>

                            <p>
                                <i className='bi bi-building me-2'></i> 100 Yapı Denetim Firması
                            </p>
                            <p>
                                <i className='bi bi-building me-2'></i> 15 Beton Santrali
                            </p>
                            <p>
                                <i className='bi bi-building me-2'></i> 20 Müteahhit
                            </p>
                        </div>
                    </div>
                </div>

                <div className='col-md-3'>
                    <div className='card'>
                        <div className='card-body'>
                            <h5 className='card-title'>Şirket Hakkında</h5>
                            <p className='card-text'>Şirketler hakkında bilgi alabilirsiniz.</p>

                            <p>
                                <i className='bi bi-person me-2'></i> 15 Çalışan
                            </p>
                            <p>
                                <i className='bi bi-truck me-2'></i> 12 Araç
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Dashboard